import PropTypes from 'prop-types';
import React from 'react';
import ButtonOutlined from 'components/Shared/Buttons/Outlined/ButtonOutlined';

import styles from './DayRateFilter.module.scss';

const MIN_DAILY_RATE = 1; // $
const MAX_DAILY_RATE = 10000; // $

const dayRateRanges = [
  // min & max values expressed in USD
  {
    label: 'Under $100',
    min: null,
    max: 100,
  },
  {
    label: '$100 - $250',
    min: 100,
    max: 250,
  },
  {
    label: '$250 - $400',
    min: 250,
    max: 400,
  },
  {
    label: '$400 - $750',
    min: 400,
    max: 750,
  },
  {
    label: 'Over $750',
    min: 750,
    max: null,
  },
];

const DayRateFilter = ({
  currentMin,
  currentMax,

  minDayRate,
  maxDayRate,

  onCustomAmountChange,

  onSelectCustomRate,
  onSelectDayRate,
}) => {
  //

  const activeIndex = dayRateRanges.findIndex(
    (range) =>
      (range.min || 0) === Number(minDayRate) &&
      (range.max || 0) === Number(maxDayRate)
  );

  const handleKeyDown = (event) => {
    // On `Enter` key press
    if (event.key === 'Enter') {
      event.preventDefault();
      event.target.blur();
      onSelectCustomRate();
      return false;
    }
  };

  return (
    <div className={styles.rateRangesContainer}>
      {/* Pre-defined day rate ranges */}
      <ul className={styles.rateRangesList}>
        {dayRateRanges.map((range, i) => (
          <li key={i.toString()}>
            <a
              className={activeIndex === i && styles.selectedRange}
              onClick={() => onSelectDayRate(range.min, range.max)}
            >
              {range.label}
            </a>
          </li>
        ))}
      </ul>

      {/* User defined day rate ranges (min, max) */}
      <div className={styles.customRatesContainer}>
        <div className={styles.customRatesItemSpacing}>
          <input
            value={currentMin}
            min={MIN_DAILY_RATE}
            max={MAX_DAILY_RATE}
            type="number"
            disabled={false}
            placeholder="Min $"
            className={`form-control ${styles.customRateInput}`}
            onKeyDown={(e) => handleKeyDown(e)}
            onChange={(e) =>
              onCustomAmountChange('currentMinRate', e.target.value)
            }
          />
        </div>

        <div className={styles.customRatesItemSpacing}>
          <input
            value={currentMax}
            min={MIN_DAILY_RATE}
            max={MAX_DAILY_RATE}
            type="number"
            disabled={false}
            placeholder="Max $"
            className={`form-control ${styles.customRateInput}`}
            onKeyDown={(e) => handleKeyDown(e)}
            onChange={(e) =>
              onCustomAmountChange('currentMaxRate', e.target.value)
            }
          />
        </div>

        <ButtonOutlined onClick={onSelectCustomRate}>Go</ButtonOutlined>
      </div>
    </div>
  );
};

DayRateFilter.propTypes = {
  currentMin: PropTypes.number,
  currentMax: PropTypes.number,

  onCustomAmountChange: PropTypes.func,

  onSelectCustomRate: PropTypes.func,
  onSelectDayRate: PropTypes.func,
};

export default DayRateFilter;
